import React from 'react';
import { Route, Switch } from 'react-router';
import ProfilePage from './containers/ProfilePage';
import PostPage from './containers/PostPage';
import CouponPage from './containers/CouponPage';
import MorePage from './containers/MorePage';
import MoreGlobalPage from './containers/MorePage/global';
import NotFoundPage from './containers/NotFoundPage';
import PortalPage from './containers/PortalPage';
import PortalErrorPage from './containers/PortalErrorPage';
import NotLoggedInPage from './containers/NotLoggedInPage';
import ProfileRecommendPage from './containers/ProfileRecommendPage';
import ProfileEventPage from './containers/ProfileEventPage';
import ProfileCategoryPage from './containers/ProfileCategoryPage';
import ProfileChatPage from './containers/ProfileChatPage';

import CustomChatPage from './containers/CustomSchemePage/chat';
import CustomBotPage from './containers/CustomSchemePage/bot';

import AddFriendPage from './containers/AddFriendPage';
import AddFriendDonePage from './containers/AddFriendDonePage';
import MaxLimitFriendPage from './containers/MaxLimitFriendPage';
import OldQRCodeLandPage from './containers/OldQRCodeLandPage';

import MembershipPage from './containers/MembershipPage';

import AgeAuthFinishPage from './containers/AgeAuthFinishPage';
import WishlistBridgePage from './containers/WishListInfoPage/WishlistBridgePage';

export default function createRoute() {
  return (
    <Switch>
      <Route exact path="/more" component={MorePage} />
      <Route exact path="/more/recommendeds" component={MorePage} />
      <Route exact path="/plus/list" component={MorePage} />
      <Route exact path="/plus/list/global" component={MoreGlobalPage} />
      <Route exact path="/profiles/:encodedProfileId/card" component={MembershipPage} />
      <Route exact path="/portal" component={PortalPage} />
      <Route exact path="/portal/recommends" component={ProfileRecommendPage} />
      <Route exact path="/portal/events/:eventId" component={ProfileEventPage} />
      <Route exact path="/portal/categories/:categoryId" component={ProfileCategoryPage} />
      <Route exact path="/logged_out" component={NotLoggedInPage} />
      <Route exact path="/ageauth/finish" component={AgeAuthFinishPage} />
      <Route exact path="/max_limit_friends" component={MaxLimitFriendPage} />
      <Route exact path="/s/:uuid" component={OldQRCodeLandPage} />
      <Route exact path="/wishlist/bridge" component={WishlistBridgePage} />
      <Route exact path="/:encodedProfileId" component={ProfilePage} />
      <Route exact path="/:encodedProfileId/chat" component={ProfileChatPage} />
      <Route exact path="/:encodedProfileId/friend" component={AddFriendPage} />
      <Route exact path="/:encodedProfileId/add_friend_done" component={AddFriendDonePage} />
      <Route exact path="/:encodedProfileId/:postId" component={PostPage} />
      <Route exact path="/:encodedProfileId/coupons/:couponId" component={CouponPage} />
      <Route exact path="/webtoapp/chat/:chatId" component={CustomChatPage} />
      <Route exact path="/webtoapp/chat/:chatId/:message" component={CustomChatPage} />
      <Route exact path="/chat/:chatId" component={CustomChatPage} />
      <Route exact path="/chat/:chatId/:message" component={CustomChatPage} />
      <Route exact path="/talk/chat/:chatId" component={CustomChatPage} />
      <Route exact path="/talk/chat/:chatId/:message" component={CustomChatPage} />
      <Route exact path="/talk/bot/:chatId" component={CustomBotPage} />
      <Route exact path="/talk/bot/:chatId/:message" component={CustomBotPage} />
      <Route path="/portal/*" component={PortalErrorPage} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/routes.js